import axios from 'axios'
import router from '../routes'
import Vue from 'vue'
const vm = new Vue()

//lls-sso服务
import newsso from 'lls-sso'
import '@babel/polyfill'

//blob文件下载
const blodFileDown = response => {
  /**
   * @description: blob转文本，处理异常
   * @param {*} blob
   */
  function blobToText(blob) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsText(blob)
      fileReader.onload = function () {
        try {
          const result = JSON.parse(this.result)
          resolve(result)
        } catch (e) {
          //TODO handle the exception
          reject(e)
        }
      }
    })
  }
  //处理
  if (response.status == 200 && response.data.type != 'application/json') {
    //application/octet-stream 才是文件流
    const blob = new Blob([response.data])
    console.log('blob接口返回的信息', response)
    //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
    //IE10以上支持blob但是依然不支持download
    let realFileName = ''
    if (response['headers']['map']) {
      realFileName = response['headers']['map']['content-disposition'][0].split(
        'filename='
      )[1]
    } else {
      realFileName = response['headers']['content-disposition'].split(
        'filename='
      )[1]
    }
    console.log(realFileName)
    //去除前后两个"并且中文解析
    const fileName = decodeURIComponent(
      realFileName.replace('"', '').replace('"', '')
    )
    console.log(fileName)
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //ie
      console.log('ie下载')
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      //guge
      console.log('谷歌下载')
      //支持a标签download的浏览器
      const link = document.createElement('a') //创建a标签
      link.download = fileName //a标签添加属性
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      document.body.appendChild(link)
      link.click() //执行下载
      URL.revokeObjectURL(link.href) //释放url
      document.body.removeChild(link) //释放标签
    }

    return
  } else {
    console.log(response, '========blob格式下载错误=========')
    // 抓取后端异常报错
    blobToText(response.data).then(res => {
      console.log(res, '========非blob下载错误=========')
      // vm.$llsMessage({text: `${res.message}`,type:'info'});
      Vue.prototype.$message.error(res.message)
    })
    // vm.$llsMessage({type: 'error',text: "网络请求失败，请联系管理员"});
    return
  }
}
// let str = location.href;
// let sso = "";
// let devURL = "lianyirong";//开发域名关键字
// let uatURL = "qhhrly";//测试域名关键字
// let prdURL = "llschain";//生产域名关键字
// let demoURL = "hrlyit";//演示环境
let ssoUrl = ''
// //判断sso需要用到什么域名
// if(str.indexOf(devURL) > -1){
//     ssoUrl = 'https://sso-web.lianyirong.com.cn' //开发环境
//     // sso = Sso('https://lls-sso.lianyirong.com.cn');//开发环境
//
// }else if(str.indexOf(uatURL) > -1){
//     ssoUrl = 'https://sso-web.qhhrly.cn'; //测试环境
//     // sso = Sso('https://lls-sso.qhhrly.cn');//测试环境
//
// }else if((str.indexOf(prdURL) > -1)){
//     ssoUrl = 'https://sso-web.llschain.com'; //生产环境
//     // sso = Sso('https://lls-sso.llschain.com');//生产环境
//
// }else if((str.indexOf(demoURL) > -1)){
//     ssoUrl = 'https://sso-web.hrlyit.com'; //演示环境
//     // sso = Sso('https://lls-sso.hrlyit.com');//演示环境
//
// }else{
//     ssoUrl = 'https://sso-web.qhhrly.cn'; //测试环境
//     // ssoUrl = 'https://sso-web.lianyirong.com.cn'; //开发环境
//     // sso = Sso('https://lls-sso.qhhrly.cn');//测试环境
// }
async function httpsAxios() {
  var ssoNew
  let alert
  let count = 0
  //http request 拦截器
  ssoNew = await newsso(ssoUrl)
  await Vue.use(ssoNew)
  axios.interceptors.request.use(ssoNew.getAxiosReqInterceptor())
  //添加自动化测试平台埋点
  axios.interceptors.request.use(
    config => {
      // let burRequest = config;
      // // console.log('埋点请求参数',burRequest);
      // burRequest["body"] = burRequest["data"] || {}
      // try {
      //     vm.$llsBuryingPoint("http",burRequest,"start");
      // }catch (e) {
      //     console.log('测试平台错误信息入参==========',e)
      // }
      //国际化语言设置请求头
      let lang =
        window.vm.$i18n.locale || localStorage.getItem('locale') || 'zh'
      let childLang = localStorage.getItem('childLocale') || 'zh'
      let Language
      if (config.childHead) {
        Language = childLang == 'zh' ? 'zh-CN' : 'en-US'
      } else {
        Language = lang == 'zh' ? 'zh-CN' : 'en-US'
      }
      config['headers']['Accept-Language'] = Language
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  //http response 拦截器
  axios.interceptors.response.use(
    ssoNew.getAxiosRespInterceptor(
      async (tag, response) => {
        //添加埋点方法
        // let burResponse = response;
        // // console.log('埋点返回参数',burResponse);
        // burResponse["url"] = burResponse["config"]["url"]
        // // burResponse["url"] = burResponse["config"]["url"].replace("/pay-web","")
        // burResponse["body"] = burResponse["data"]

        // try {
        //     vm.$llsBuryingPoint("http",burResponse,"end");
        // }catch (e) {
        //     console.log('测试平台错误信息返回==========',e)
        // }
        //lls-sso处理

        if (tag == 'success') {
          // console.log('接口返回的信息',response)

          let res = {}
          res.body = response.data || {}
          res.data = response.data || {}
          // console.log(res,'处理信息=======');
          //自己处理返回参数
          if (response.config.handingResponse) return res
          //下载文件流处理（报错信息返回的）
          // if(response.headers['content-disposition']){
          if (response.config.responseType == 'blob') {
            blodFileDown(response)
            return
          }
          //一些统一code的返回处理
          let resCode = res.data.code || res.data.httpCode
          // 暂无响应，请联系管理员
          let errMsg =
            res.data.message ||
            res.data.msg ||
            window.vm.$t('login.serverNotRsponding')
          if (resCode == '200') {
            //请求成功直接返回
            return res
          } else if (resCode == '01100' || resCode == '10900') {
            if (count == 0) {
              // 提示 重新登录
              alert = Vue.prototype.$alert(errMsg, window.vm.$t('login.tips'), {
                confirmButtonText: window.vm.$t('login.loginAgain'),
                callback: action => {
                  const redirect = router.currentRoute.path
                  const query = router.currentRoute.query
                  if (
                    redirect === '/childDocExchange/pendingTask' ||
                    redirect === '/childDocExchange/transactionDetails'
                  ) {
                    router.replace({
                      path: '/login',
                      query: { redirect, ...query },
                    })
                  } else {
                    router.replace('/login')
                  }

                  setTimeout(() => {
                    count = 0
                  }, 5000)
                },
              })
              count++
            }
            return Promise.reject(errMsg)
          } else {
            // else if(resCode == '10200'){
            //     //会话过期的
            //     vm.$llsAlert({text: errMsg,title: "提示",buttonList:[{level: "1",text: "重新登录",
            //             click: ()=>{
            //                 router.replace("/login")
            //             }}]});
            //
            // }
            if (response.config.handingResponseErrMsg) {
              //错误信息单独处理
              return Promise.reject(errMsg)
            } else {
              //直接抛出错误信息
              //ip白名单限制
              if (resCode == '830005') {
                // 退回登录页
                router.replace('/login')
              }

              Vue.prototype.$message.error(errMsg)
              return Promise.reject(errMsg)
            }
          }
        }
        //刷新页面
        if (tag == 'refresh') {
          // router.push({name:'newIndex'})
          // window.location.reload()
          return response
        }
        //把上一次暂停的请求继续下去
        if (tag == 'request') {
          return axios.request(response.config)
        }
        //重定向回login
        if (tag == 'redirect') {
          // 暂无响应，请联系管理员
          let errMsg =
            response.data.message ||
            response.data.msg ||
            window.vm.$t('login.serverNotRsponding')
          if (count == 0) {
            console.log('router:', router)
            // 提示 重新登录
            alert = Vue.prototype.$alert(errMsg, window.vm.$t('login.tips'), {
              confirmButtonText: window.vm.$t('login.loginAgain'),
              callback: action => {
                const redirect = router.currentRoute.path
                const query = router.currentRoute.query
                if (
                  redirect === '/childDocExchange/pendingTask' ||
                  redirect === '/childDocExchange/transactionDetails' || 
                  redirect === '/AdvanceCredit'
                ) {
                  router.replace({
                    path: '/login',
                    query: { redirect, ...query },
                  })
                } else {
                  router.replace('/login')
                }
                setTimeout(() => {
                  count = 0
                }, 5000)
              },
            })
            count++
          }
          return Promise.reject(errMsg)
        }
      },
      err => {
        console.log('错误', err)
        return Promise.reject(err)
      }
    )
  )
  Vue.prototype.$http = axios
  Vue.http = axios
}

export default httpsAxios
